var _path, _path2, _path3, _mask, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7L12 13V23L2 17V7Z",
    fill: "#C3B9D2",
    fillOpacity: 0.08,
    stroke: "#C3B9D2",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13L22 7V17L12 23V13Z",
    fill: "#C3B9D2",
    fillOpacity: 0.16,
    stroke: "#C3B9D2",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13L22 7L12 1L2 7L12 13Z",
    stroke: "#C3B9D2",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_0_53",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49476 10.2862L7.5 10.2892V15.363C7.5 15.5185 7.33027 15.6145 7.19697 15.5344L6.74242 15.2612C6.59201 15.1708 6.5 15.0081 6.5 14.8326V9.72062L16.8326 3.51744L17.686 4.1715L7.49476 10.2862Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49476 10.2862L6.98027 9.42874L5.51247 10.3094L7.00047 11.1555L7.49476 10.2862ZM7.5 10.2892H8.5V9.70747L7.9943 9.41992L7.5 10.2892ZM6.5 9.72062L5.98528 8.86326L5.5 9.1546V9.72062H6.5ZM16.8326 3.51744L17.441 2.72375L16.9011 2.30997L16.3179 2.66008L16.8326 3.51744ZM17.686 4.1715L18.2005 5.02899L19.4615 4.27238L18.2943 3.3778L17.686 4.1715ZM6.74242 15.2612L6.22727 16.1183L6.74242 15.2612ZM7.19697 15.5344L7.71212 14.6773L7.19697 15.5344ZM7.00047 11.1555L7.0057 11.1585L7.9943 9.41992L7.98906 9.41694L7.00047 11.1555ZM6.5 10.2892V15.363H8.5V10.2892H6.5ZM7.71212 14.6773L7.25758 14.4041L6.22727 16.1183L6.68181 16.3915L7.71212 14.6773ZM7.5 14.8326V9.72062H5.5V14.8326H7.5ZM7.01472 10.578L17.3473 4.3748L16.3179 2.66008L5.98528 8.86326L7.01472 10.578ZM16.2243 4.31113L17.0777 4.96519L18.2943 3.3778L17.441 2.72375L16.2243 4.31113ZM17.1715 3.314L6.98027 9.42874L8.00926 11.1437L18.2005 5.02899L17.1715 3.314ZM7.25758 14.4041C7.40799 14.4945 7.5 14.6571 7.5 14.8326H5.5C5.5 15.3591 5.77602 15.8471 6.22727 16.1183L7.25758 14.4041ZM6.5 15.363C6.5 14.7409 7.17892 14.3568 7.71212 14.6773L6.68181 16.3915C7.48163 16.8722 8.5 16.2961 8.5 15.363H6.5Z",
    fill: "#C3B9D2",
    mask: "url(#path-4-inside-1_0_53)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.4bd1a8544fb754f8959a7f91fac57eec.svg";
export { ForwardRef as ReactComponent };